import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'app-confirm-message',
    templateUrl: './confirm-message.component.html',
    styleUrls: ['./confirm-message.component.scss'],
    standalone: false
})
export class ConfirmMessageComponent implements OnInit {
  @Input() showForm: boolean;
  @Input() message: string;
  @Input() color: string; // Success, Primary or Danger...
  @Output() onConfirm = new EventEmitter();
  @Output() onCancel = new EventEmitter();
  constructor(public globalService: GlobalService) {}

  ngOnInit(): void {}

  Confirm() {
    this.onConfirm.emit();
  }

  Cancel() {
    this.showForm = false;
    this.onCancel.emit();
  }
}
 